export const translations = {
    en: {
        title: "HevMed Medicals Interview Panel",
        welcome: "Welcome to the HevMed Medicals Interview Panel.",
        introText: "This assessment will help us evaluate your knowledge and suitability for working in a pharmacy environment. Please answer all questions honestly.",
        estimatedTime: "Estimated time: 10–15 minutes.",
        startInterview: "Start Interview",
        next: "Next",
        submit: "Submit",
        personalDetails: "Personal Details",
        fullName: "Full Name",
        phoneNumber: "Phone Number",
        altPhoneNumber: "Alternate Phone Number",
        currentAddress: "Current Address",
        permanentAddress: "Permanent Address",
        aadharNumber: "Aadhar Card Number",
        dob: "Date of Birth",
        gender: "Gender",
        male: "Male",
        female: "Female",
        other: "Other",
        education: "Highest Education Qualification",
        medicalExp: "Medical Store Experience",
        totalExp: "Total Experience",
        prevCompany: "Previous Company / Medical Store",
        currentSalary: "Current Salary",
        expectedSalary: "Expected Salary",
        availability: "Joining Availability",
        yes: "Yes",
        no: "No",
        fresher: "Fresher",
        exp01: "0-1 year",
        exp13: "1-3 years",
        exp3plus: "3+ years",
        immediate: "Immediate",
        days7: "7 days",
        days15: "15 days",
        days30: "30 days",
        pharmacyKnowledge: "Pharmacy Knowledge",
        customerHandling: "Customer Handling",
        situationalQuestions: "Situational Questions",
        score: "Score",
        result: "Result",
        examTerminated: "Exam Terminated",
        reason: "Reason",
        correct: "Correct",
        incorrect: "Incorrect",
        adminLogin: "Admin Login",
        email: "Email Address",
        password: "Password",
        login: "Login",
        invalidCredentials: "Invalid email or password",
        step: "Step",
        of: "of",
        previous: "Previous",
        finish: "Finish",
        mcq: "Multiple Choice",
        text: "Text / Descriptive",
        selectType: "Select Question Type",
        writeAnswer: "Write your answer here...",
        submissionMessage: "Thank you for submitting. You can now close this window and inform the interviewer.",
        loadingQuestions: "Loading interview questions...",
        duration: "Duration",
        questionsLabel: "Questions",
        randomQuestionsInfo: "{count} random questions from the question bank",
        questionProgress: "Question",
        timeTaken: "Time Taken",
        duplicatePhone: "This phone number has already submitted an attempt.",
        phoneCheckFailed: "Could not verify phone number. Please try again.",
        checkingPhone: "Checking...",
        fieldRequired: "This field is required",
        phoneRequired: "Phone number must be 10 digits",
        aadharRequired: "Aadhar number must be 12 digits",
        dobMinAge: "You must be at least 18 years old",
        dashboard: "Dashboard",
        manageQuestions: "Manage Questions",
        viewResults: "View Results",
        adminPanel: "Admin Panel",
        adminLoginDesc: "Manage interview questions, view candidate results, and track performance analytics.",
        adminLoginSubtitle: "Sign in to access the dashboard",
        adminWelcome: "Welcome back! Here's your overview.",
        backToApp: "Back to Interview",
        dashboardEmptyHint: "Results will appear here once candidates complete the assessment.",
        logout: "Logout",
        cancel: "Cancel",
        retry: "Retry",
        totalParticipants: "Total Participants",
        totalAttempts: "Total Attempts",
        averageScore: "Average Score",
        highestScore: "Highest Score",
        lowestScore: "Lowest Score",
        scoreDistribution: "Score Distribution",
        attemptsOverTime: "Attempts (Last 30 Days)",
        noResultsYet: "No results yet.",
        searchPlaceholder: "Search by name or phone...",
        allLanguages: "All Languages",
        minScore: "Min %",
        maxScore: "Max %",
        exportCSV: "Export CSV",
        exportPDF: "Export PDF",
        submissionDate: "Submission Date",
        action: "Action",
        viewDetails: "View Details",
        showing: "Showing",
        perPage: "page",
        noMatchingResults: "No matching results found.",
        backToResults: "Back to Results",
        participantDetails: "Participant Details",
        quizPerformance: "Quiz Performance",
        typingPerformance: "Typing Performance",
        candidateInfo: "Candidate Information",
        noTypingData: "No typing test data for this attempt",
        typingDuration: "Duration",
        examReview: "Exam Review",
        userAnswer: "Your Answer",
        correctAnswer: "Correct Answer",
        noAnswer: "No answer",
        questionDataMissing: "Question data missing",
        searchQuestions: "Search questions...",
        allSections: "All Sections",
        questionsTotal: "questions",
        noMatchingQuestions: "No matching questions found.",
        emptyQuestion: "(Empty question)",
        selectCorrect: "Select Correct Option",
        hindiAnswer: "Hindi Answer",
        syncedFromEnglish: "(Synchronized from English)",
        autoTranslate: "Auto-Translate to Hindi",
        deleteQuestion: "Delete Question",
        confirmDelete: "Are you sure you want to delete this question?",
        addQuestion: "Add New Question",
        examConfiguration: "Exam Configuration",
        questionLimit: "Interview Question Limit",
        questionLimitHint: "Random MCQ count shown to each candidate (numbers only, e.g. 15)",
        questionLimitInvalid: "Enter a valid number (minimum 1)",
        paragraphsTab: "Paragraph",
        questionsTab: "Questions",
        paragraphsUsed: "paragraphs",
        typingPassagesConfig: "Typing Speed Passages",
        typingPassagePlaceholder: "Type the passage candidates will copy during the typing speed test...",
        typingPassagesHint: "Add as many paragraphs as you need. Each candidate gets one random passage in the typing test.",
        typingPassageLabel: "Paragraph",
        addTypingPassage: "Add Paragraph",
        typingPassageRequired: "Add at least one typing passage",
        typingPassageMax: "Maximum 5 paragraphs allowed",
        addQuestionDesc: "Fill in the question details below. It will be added to the list when you click Add to List.",
        addToList: "Add to List",
        questionRequired: "English question text is required.",
        optionsRequired: "Please fill at least 2 options.",
        correctAnswerRequired: "Please select the correct answer.",
        saveAll: "Save All Changes",
        saving: "Saving...",
        questionsSaved: "Questions saved successfully!",
        dbUnreachable: "Cloud database is not reachable right now. Showing local default questions.",
        cloudSaveFailed: "Cloud save failed, but your questions were saved locally in this browser.",
        translationFailed: "Translation failed. Please try again.",
        acceptAndStart: "Accept & Start Exam",
        violationTitle: "Rule Violation Detected",
        violationMessage: "You have violated the exam rules (tab switch or exit fullscreen).",
        attemptsLeft: "Attempts left",
        violationWarning: "Further violations will terminate your session automatically.",
        continueExam: "Continue Exam",
        medicalAssessment: "Medical Assessment",
        interviewPanel: "Interview Assessment Panel",
        bilingual: "Language",
        bilingualDesc: "English & Hindi supported",
        formStep1: "Personal Info",
        formStep2: "Identity",
        formStep3: "Experience",
        permissionModal: {
            title: "HevMed Medicals",
            subtitle: "Exam Rules & Permissions",
            instruction: "Please read carefully before starting the exam.",
            rules: {
                fullscreen: "Fullscreen mode is mandatory",
                tabSwitch: "Tab switching is not allowed",
                refreshClose: "Refreshing or closing will fail the exam",
                violation: "Violations lead to automatic failure"
            }
        },
        typingTestTitle: "Typing Speed Test",
        typingTestInstruction: "Type the passage below. The 30-second timer starts when you press your first key.",
        typingWpm: "WPM",
        typingAccuracy: "Accuracy",
        typingChars: "Characters",
        typingTestComplete: "Typing test complete",
        startTyping: "Start typing",
        secondsLeft: "Time left",
        typingTestReview: "Typing Test Review",
        typingPassage: "Passage vs typed text",
    },
    hi: {
        title: "HevMed Medicals इंटरव्यू पैनल",
        welcome: "HevMed Medicals इंटरव्यू पैनल में आपका स्वागत है।",
        introText: "यह परीक्षण मेडिकल स्टोर में काम करने के लिए आपकी जानकारी और योग्यता का मूल्यांकन करने के लिए बनाया गया है। कृपया सभी प्रश्नों का उत्तर ईमानदारी से दें।",
        estimatedTime: "समय: 10–15 मिनट।",
        startInterview: "इंटरव्यू शुरू करें",
        next: "अगला",
        submit: "जमा करें",
        personalDetails: "व्यक्तिगत विवरण",
        fullName: "पूरा नाम",
        phoneNumber: "फोन नंबर",
        altPhoneNumber: "वैकल्पिक फोन नंबर",
        currentAddress: "वर्तमान पता",
        permanentAddress: "स्थायी पता",
        aadharNumber: "आधार कार्ड नंबर",
        dob: "जन्म तिथि",
        gender: "लिंग",
        male: "पुरुष",
        female: "महिला",
        other: "अन्य",
        education: "उच्चतम शिक्षा योग्यता",
        medicalExp: "मेडिकल स्टोर का अनुभव",
        totalExp: "कुल अनुभव",
        prevCompany: "पिछली कंपनी / मेडिकल स्टोर",
        currentSalary: "वर्तमान वेतन",
        expectedSalary: "अपेक्षित वेतन",
        availability: "शामिल होने की उपलब्धता",
        yes: "हाँ",
        no: "नहीं",
        fresher: "फ्रेशर",
        exp01: "0-1 वर्ष",
        exp13: "1-3 वर्ष",
        exp3plus: "3+ वर्ष",
        immediate: "तुरंत",
        days7: "7 दिन",
        days15: "15 दिन",
        days30: "30 दिन",
        pharmacyKnowledge: "फार्मेसी ज्ञान",
        customerHandling: "ग्राहक हैंडलिंग",
        situationalQuestions: "स्थितिजन्य प्रश्न",
        score: "स्कोर",
        result: "परिणाम",
        examTerminated: "परीक्षा समाप्त कर दी गई",
        reason: "कारण",
        correct: "सही",
        incorrect: "गलत",
        adminLogin: "व्यवस्थापक लॉगिन",
        email: "ईमेल पता",
        password: "पासवर्ड",
        login: "लॉगिन करें",
        invalidCredentials: "अमान्य ईमेल या पासवर्ड",
        step: "चरण",
        of: "का",
        previous: "पिछला",
        finish: "समाप्त करें",
        mcq: "बहुविकल्पीय",
        text: "लिखित / वर्णनात्मक",
        selectType: "प्रश्न का प्रकार चुनें",
        writeAnswer: "अपना उत्तर यहाँ लिखें...",
        submissionMessage: "जमा करने के लिए धन्यवाद। अब आप इस विंडो को बंद कर सकते हैं और इंटरव्यूअर को सूचित कर सकते हैं।",
        loadingQuestions: "इंटरव्यू प्रश्न लोड हो रहे हैं...",
        duration: "अवधि",
        questionsLabel: "प्रश्न",
        randomQuestionsInfo: "प्रश्न बैंक से {count} यादृच्छिक प्रश्न",
        questionProgress: "प्रश्न",
        timeTaken: "लिया गया समय",
        duplicatePhone: "यह फोन नंबर पहले ही प्रयास जमा कर चुका है।",
        phoneCheckFailed: "फोन नंबर सत्यापित नहीं हो सका। कृपया पुनः प्रयास करें।",
        checkingPhone: "जाँच हो रही है...",
        fieldRequired: "यह फ़ील्ड आवश्यक है",
        phoneRequired: "फोन नंबर 10 अंकों का होना चाहिए",
        aadharRequired: "आधार नंबर 12 अंकों का होना चाहिए",
        dobMinAge: "आपकी आयु कम से कम 18 वर्ष होनी चाहिए",
        dashboard: "डैशबोर्ड",
        manageQuestions: "प्रश्न प्रबंधन",
        viewResults: "परिणाम देखें",
        adminPanel: "व्यवस्थापक पैनल",
        adminLoginDesc: "इंटरव्यू प्रश्न प्रबंधित करें, उम्मीदवार परिणाम देखें और प्रदर्शन विश्लेषण ट्रैक करें।",
        adminLoginSubtitle: "डैशबोर्ड एक्सेस करने के लिए साइन इन करें",
        adminWelcome: "वापसी पर स्वागत है! यहाँ आपका अवलोकन है।",
        backToApp: "इंटरव्यू पर वापस",
        dashboardEmptyHint: "उम्मीदवारों के मूल्यांकन पूरा करने के बाद परिणाम यहाँ दिखाई देंगे।",
        logout: "लॉगआउट",
        cancel: "रद्द करें",
        retry: "पुनः प्रयास",
        totalParticipants: "कुल प्रतिभागी",
        totalAttempts: "कुल प्रयास",
        averageScore: "औसत स्कोर",
        highestScore: "उच्चतम स्कोर",
        lowestScore: "न्यूनतम स्कोर",
        scoreDistribution: "स्कोर वितरण",
        attemptsOverTime: "प्रयास (पिछले 30 दिन)",
        noResultsYet: "अभी तक कोई परिणाम नहीं।",
        searchPlaceholder: "नाम या फोन से खोजें...",
        allLanguages: "सभी भाषाएँ",
        minScore: "न्यूनतम %",
        maxScore: "अधिकतम %",
        exportCSV: "CSV निर्यात",
        exportPDF: "PDF निर्यात",
        submissionDate: "जमा करने की तिथि",
        action: "कार्रवाई",
        viewDetails: "विवरण देखें",
        showing: "दिखा रहे हैं",
        perPage: "प्रति पृष्ठ",
        noMatchingResults: "कोई मिलान परिणाम नहीं मिला।",
        backToResults: "परिणामों पर वापस",
        examReview: "परीक्षा समीक्षा",
        userAnswer: "आपका उत्तर",
        correctAnswer: "सही उत्तर",
        noAnswer: "कोई उत्तर नहीं",
        questionDataMissing: "प्रश्न डेटा गायब",
        searchQuestions: "प्रश्न खोजें...",
        allSections: "सभी अनुभाग",
        questionsTotal: "प्रश्न",
        noMatchingQuestions: "कोई मिलान प्रश्न नहीं मिला।",
        emptyQuestion: "(खाली प्रश्न)",
        selectCorrect: "सही विकल्प चुनें",
        hindiAnswer: "हिंदी उत्तर",
        syncedFromEnglish: "(अंग्रेजी से समन्वयित)",
        autoTranslate: "हिंदी में स्वतः अनुवाद",
        deleteQuestion: "प्रश्न हटाएं",
        confirmDelete: "क्या आप वाकई इस प्रश्न को हटाना चाहते हैं?",
        addQuestion: "नया प्रश्न जोड़ें",
        addQuestionDesc: "नीचे प्रश्न विवरण भरें। सूची में जोड़ें पर क्लिक करने पर यह सूची में जुड़ जाएगा।",
        addToList: "सूची में जोड़ें",
        questionRequired: "अंग्रेजी प्रश्न आवश्यक है।",
        optionsRequired: "कृपया कम से कम 2 विकल्प भरें।",
        correctAnswerRequired: "कृपया सही उत्तर चुनें।",
        saveAll: "सभी परिवर्तन सहेजें",
        saving: "सहेजा जा रहा है...",
        questionsSaved: "प्रश्न सफलतापूर्वक सहेजे गए!",
        dbUnreachable: "क्लाउड डेटाबेस अभी उपलब्ध नहीं है। स्थानीय डिफ़ॉल्ट प्रश्न दिखाए जा रहे हैं।",
        cloudSaveFailed: "क्लाउड सेव विफल, लेकिन आपके प्रश्न इस ब्राउज़र में स्थानीय रूप से सहेजे गए।",
        translationFailed: "अनुवाद विफल। कृपया पुनः प्रयास करें।",
        acceptAndStart: "स्वीकार करें और परीक्षा शुरू करें",
        violationTitle: "नियम उल्लंघन का पता चला",
        violationMessage: "आपने परीक्षा नियमों का उल्लंघन किया है (टैब स्विच या फुलस्क्रीन से बाहर निकलना)।",
        attemptsLeft: "शेष प्रयास",
        violationWarning: "आगे के उल्लंघन से आपका सत्र स्वचालित रूप से समाप्त हो जाएगा।",
        continueExam: "परीक्षा जारी रखें",
        medicalAssessment: "चिकित्सा मूल्यांकन",
        interviewPanel: "इंटरव्यू मूल्यांकन पैनल",
        bilingual: "भाषा",
        bilingualDesc: "अंग्रेजी और हिंदी समर्थित",
        formStep1: "व्यक्तिगत जानकारी",
        formStep2: "पहचान",
        formStep3: "अनुभव",
        permissionModal: {
            title: "HevMed Medicals",
            subtitle: "परीक्षा नियम और अनुमतियां",
            instruction: "कृपया परीक्षा शुरू करने से पहले ध्यान से पढ़ें।",
            rules: {
                fullscreen: "फुलस्क्रीन मोड अनिवार्य है",
                tabSwitch: "टैब स्विच करने की अनुमति नहीं है",
                refreshClose: "रिफ्रेश करने या बंद करने से परीक्षा विफल हो जाएगी",
                violation: "उल्लंघन से स्वचालित विफलता होगी"
            }
        },
    }
};
